module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"frontmatter":{"title":"Setting off: Rio de Janeiro via Lisbon","path":"/rio-via-lison"}}}]}},"pathContext":{"tag":"travel"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-travel.json
// module id = 418
// module chunks = 166785445508668